import * as React from 'react';

import { Specialization_ProductVariant as SpecializationProductVariant } from '__generated__/graphql-types';

import type { ButtonProps } from '@coursera/coursera-ui';
import { Button } from '@coursera/coursera-ui';

import withLogin from 'bundles/coursera-ui/components/hocs/withLogin';
import MiniSDPInfoRows from 'bundles/coursera-ui/components/rich/MiniSDPInfoRows';
import MultiCourseProductCardHeader from 'bundles/enterprise-legacy-learner-home/components/multiCourseProductCard/MultiCourseProductCardHeader';
import ProgramActionButtonContainer from 'bundles/enterprise-legacy-learner-home/components/programActionButton/ProgramActionButtonContainer';
import { PRODUCT_TYPES } from 'bundles/enterprise-legacy-learner-home/constants/ProgramActionConstants';
import type { S12nCardSpecialization_SpecializationFragment as Specialization } from 'bundles/enterprise-legacy-learner-home/queries/__generated__/S12nCardSpecializationQuery';
import withMiniModal, { DESCRIPTION_PAGE_PATHS } from 'bundles/enterprise-legacy-xdp/hocs/withMiniModal';

import _t from 'i18n!nls/program-home';

const ViewDetailsBtnWithMiniModal = withMiniModal<ButtonProps>()(Button);
const ProgramActionButtonWithLogin = withLogin(ProgramActionButtonContainer);

const S12nNotEnrolledCard = ({
  s12n: {
    id,
    name,
    slug,
    cardImageUrl,
    descriptionAsPlainText,
    partners,
    courseCount,
    capstoneCourses,
    productVariant,
  },

  programId,
}: {
  programId: string;
  s12n: Specialization;
}) => {
  return (
    <div className="rc-S12nNotEnrolledCard" data-e2e={`S12nNotEnrolledCard~${id}`}>
      <MultiCourseProductCardHeader
        name={name}
        slug={slug}
        id={id}
        logo={cardImageUrl}
        description={descriptionAsPlainText}
        partners={partners}
        isEnrolled={false}
        productVariant={productVariant}
      >
        <MiniSDPInfoRows
          courseCount={courseCount - capstoneCourses.length}
          capstoneProjectCount={capstoneCourses.length}
        />
        <div className="horizontal-box align-items-right align-items-vertical-center p-t-1">
          <ViewDetailsBtnWithMiniModal
            miniModalProps={{
              isCourse: false,
              id,
              unifiedDescriptionPageProps: {
                slug,
                productPagePath:
                  productVariant === SpecializationProductVariant.NormalS12N
                    ? DESCRIPTION_PAGE_PATHS.specialization
                    : DESCRIPTION_PAGE_PATHS.professionalCertificate,
              },
            }}
            type="link"
            size="sm"
            label={_t('View Details')}
          />
          <ProgramActionButtonWithLogin
            loggedoutBtnAttributes={{
              label: _t('Enroll'),
              size: 'sm',
            }}
            loginHashHistoryReplacement="autoEnroll/specialization/id"
            programId={programId}
            productId={id}
            productType={PRODUCT_TYPES.SPECIALIZATION}
            actionType="ENROLL"
            initialBtnLabel={_t('Enroll')}
            btnAttributes={{
              type: 'primary',
              size: 'sm',
              htmlAttributes: {
                'data-e2e': `ProgramActionButtonContainer~${id}`,
              },
            }}
            trackingInfo={{
              trackingData: { s12nId: id },
              trackingName: 's12n_enroll_button',
            }}
          />
        </div>
      </MultiCourseProductCardHeader>
    </div>
  );
};

export default S12nNotEnrolledCard;
